{
  "schemaVersion": 1,
  "packId": "ccd-24-36-2026-09",
  "ageBands": ["24-36-months"],
  "activities": [
    {
      "activityId": "ccd.24-36.count-together",
      "skillId": "early.math.count-together.24-36",
      "title": "Contare insieme oggetti familiari",
      "ageBands": ["24-36-months"],
      "mode": "caregiver-mediated",
      "developmentalDomain": "Numero, linguaggio e attenzione condivisa",
      "objective": "Contare insieme pochi oggetti reali e familiari, collegando parole-numero e quantità senza trasformare il gioco in una verifica.",
      "sourceMappings": [
        {
          "sourceId": "who-unicef-ccd-2012",
          "locator": "Participant Manual · Recommendations · For the child, 2 years and older · pp. 20–21 · PLAY; Counselling Cards · 2 YEARS AND OLDER · PLAY",
          "rationale": "CCD indica che dai 2 anni i bambini imparano a nominare e contare e raccomanda al caregiver di chiedere 'how many' e contare le cose insieme."
        },
        {
          "sourceId": "it-mim-dm-43-2022",
          "locator": "Orientamenti nazionali 0–3 · gioco, esplorazione, linguaggi, esperienza quotidiana e iniziativa del bambino",
          "rationale": "L’attività usa oggetti reali e una relazione responsiva, non schede o drill."
        },
        {
          "sourceId": "who-under5-24h-2019",
          "locator": "Recommendations · sedentary screen time · children aged 2 years",
          "rationale": "L’app dà solo una breve consegna all’adulto; il conteggio avviene fuori dallo schermo."
        }
      ],
      "materials": ["2–5 oggetti grandi, familiari e sicuri già presenti nell’ambiente"],
      "safetyConstraints": [
        "Supervisione dell’adulto durante la manipolazione.",
        "Usare solo oggetti adatti all’età, non ingeribili, non fragili e senza parti staccabili pericolose.",
        "Non correggere in modo punitivo né chiedere prestazioni ripetute contro l’interesse del bambino."
      ],
      "observationSignals": [
        "Il bambino partecipa al conteggio con sguardo, gesto, parola o manipolazione.",
        "Il bambino accetta di ricontare oppure cambia spontaneamente il gruppo di oggetti.",
        "L’adulto segue il ritmo del bambino senza trasformare l’attività in test."
      ],
      "adaptation": {
        "ifEasy": "Aggiungere un solo oggetto oppure contare un secondo piccolo gruppo, mantenendo il gioco breve.",
        "ifHard": "Ridurre a due oggetti e contarli lentamente insieme indicando ciascun oggetto una sola volta.",
        "stopRule": "Interrompere se il bambino perde interesse, si irrita o l’attività smette di essere giocosa."
      },
      "screen": {
        "classification": "adult-coach-off-screen",
        "expectedOnScreenSeconds": 20
      },
      "diagnosticUse": "none",
      "status": "implemented"
    },
    {
      "activityId": "ccd.24-36.name-and-compare",
      "skillId": "early.cognition.name-compare.24-36",
      "title": "Nominare e confrontare cose",
      "ageBands": ["24-36-months"],
      "mode": "caregiver-mediated",
      "developmentalDomain": "Linguaggio, concetti e confronto",
      "objective": "Nominare oggetti familiari e confrontarne una caratteristica evidente, come grande/piccolo, seguendo ciò che interessa al bambino.",
      "sourceMappings": [
        {
          "sourceId": "who-unicef-ccd-2012",
          "locator": "Participant Manual · Recommendations · For the child, 2 years and older · pp. 20–21 · PLAY/COMMUNICATE",
          "rationale": "CCD raccomanda di aiutare il bambino a contare, nominare e confrontare cose e propone domande semplici come 'Which ball is bigger?'."
        },
        {
          "sourceId": "it-mim-dm-43-2022",
          "locator": "Orientamenti nazionali 0–3 · esplorazione, comunicazione, relazioni e costruzione di significati nell’esperienza",
          "rationale": "Il confronto nasce dall’esperienza concreta e dal dialogo adulto-bambino."
        }
      ],
      "materials": ["Due oggetti familiari e sicuri con una differenza evidente, per esempio dimensione o forma"],
      "safetyConstraints": [
        "Usare oggetti adatti all’età e sotto supervisione.",
        "Proporre una sola caratteristica alla volta.",
        "Accettare gesti, indicazioni e parole senza esigere una risposta verbale."
      ],
      "observationSignals": [
        "Il bambino guarda o indica uno degli oggetti durante il confronto.",
        "Il bambino prova a nominare, scegliere o distinguere una caratteristica.",
        "Lo scambio resta reciproco e non valutativo."
      ],
      "adaptation": {
        "ifEasy": "Cambiare coppia di oggetti o usare una seconda caratteristica evidente.",
        "ifHard": "Usare due oggetti molto diversi e modellare una volta il confronto senza chiedere una risposta obbligatoria.",
        "stopRule": "Concludere quando il bambino cambia interesse o non vuole più confrontare gli oggetti."
      },
      "screen": {
        "classification": "adult-coach-off-screen",
        "expectedOnScreenSeconds": 20
      },
      "diagnosticUse": "none",
      "status": "implemented"
    },
    {
      "activityId": "ccd.24-36.match-colours",
      "skillId": "early.cognition.match-colours.24-36",
      "title": "Abbinare colori",
      "ageBands": ["24-36-months"],
      "mode": "caregiver-mediated",
      "developmentalDomain": "Classificazione e percezione",
      "objective": "Abbinare o raggruppare pochi oggetti reali in base a colori chiaramente distinguibili.",
      "sourceMappings": [
        {
          "sourceId": "who-unicef-ccd-2012",
          "locator": "Participant Manual · Recommendations · For the child, 2 years and older · p. 20 · PLAY",
          "rationale": "CCD afferma che i bambini possono imparare ad abbinare colori, forme e dimensioni con oggetti semplici."
        },
        {
          "sourceId": "it-mim-dm-43-2022",
          "locator": "Orientamenti nazionali 0–3 · esplorazione di materiali, gioco e organizzazione dell’esperienza",
          "rationale": "La classificazione avviene manipolando materiali concreti e in forma ludica."
        }
      ],
      "materials": ["4–6 oggetti grandi e sicuri in due colori chiaramente diversi"],
      "safetyConstraints": [
        "Evitare piccoli oggetti suggeriti negli esempi storici del manuale se non sono sicuri per l’età.",
        "Usare materiali non ingeribili, puliti e privi di parti staccabili o bordi pericolosi.",
        "Non richiedere la denominazione del colore per considerare valida la partecipazione."
      ],
      "observationSignals": [
        "Il bambino prova ad avvicinare o raggruppare oggetti dello stesso colore.",
        "Il bambino nota differenze cromatiche o segue una dimostrazione semplice.",
        "Il bambino modifica il raggruppamento liberamente durante il gioco."
      ],
      "adaptation": {
        "ifEasy": "Aggiungere un terzo colore mantenendo pochi oggetti complessivi.",
        "ifHard": "Usare solo due coppie con colori molto contrastanti e mostrare un abbinamento iniziale.",
        "stopRule": "Interrompere se il bambino perde interesse o inizia a usare i materiali in modo non sicuro."
      },
      "screen": {
        "classification": "adult-coach-off-screen",
        "expectedOnScreenSeconds": 20
      },
      "diagnosticUse": "none",
      "status": "implemented"
    },
    {
      "activityId": "ccd.24-36.match-shapes",
      "skillId": "early.cognition.match-shapes.24-36",
      "title": "Abbinare forme",
      "ageBands": ["24-36-months"],
      "mode": "caregiver-mediated",
      "developmentalDomain": "Classificazione, forma e problem solving",
      "objective": "Confrontare e abbinare poche forme semplici usando oggetti o sagome grandi e sicure.",
      "sourceMappings": [
        {
          "sourceId": "who-unicef-ccd-2012",
          "locator": "Participant Manual · Recommendations · For the child, 2 years and older · p. 20 · PLAY",
          "rationale": "CCD raccomanda esplicitamente il matching e sorting di forme con oggetti semplici."
        },
        {
          "sourceId": "it-mim-dm-43-2022",
          "locator": "Orientamenti nazionali 0–3 · esplorazione, materiali e pluralità dei linguaggi",
          "rationale": "La forma viene esplorata concretamente, senza anticipare schede scolastiche."
        }
      ],
      "materials": ["2–3 coppie di oggetti o sagome grandi con forme chiaramente distinguibili"],
      "safetyConstraints": [
        "Sagome e oggetti devono essere abbastanza grandi da non essere ingeribili.",
        "Evitare bordi taglienti, materiali fragili o piccoli ritagli liberi.",
        "Supervisione continua dell’adulto."
      ],
      "observationSignals": [
        "Il bambino prova a mettere insieme forme simili.",
        "Il bambino esplora contorni e differenze anche senza completare l’abbinamento.",
        "Il bambino ripete o varia spontaneamente il gioco."
      ],
      "adaptation": {
        "ifEasy": "Aggiungere una terza forma o variare la dimensione mantenendo la forma riconoscibile.",
        "ifHard": "Usare una sola coppia per forma e forme molto diverse tra loro.",
        "stopRule": "Concludere se il bambino non è interessato o il materiale diventa non sicuro."
      },
      "screen": {
        "classification": "adult-coach-off-screen",
        "expectedOnScreenSeconds": 20
      },
      "diagnosticUse": "none",
      "status": "implemented"
    },
    {
      "activityId": "ccd.24-36.match-sizes",
      "skillId": "early.cognition.match-sizes.24-36",
      "title": "Confrontare e abbinare dimensioni",
      "ageBands": ["24-36-months"],
      "mode": "caregiver-mediated",
      "developmentalDomain": "Classificazione, confronto e linguaggio",
      "objective": "Confrontare pochi oggetti simili distinguendo dimensioni chiaramente diverse e provare ad abbinarli o ordinarli.",
      "sourceMappings": [
        {
          "sourceId": "who-unicef-ccd-2012",
          "locator": "Participant Manual · Recommendations · For the child, 2 years and older · pp. 20–21 · PLAY/COMMUNICATE",
          "rationale": "CCD include esplicitamente il matching delle dimensioni e il confronto tra cose."
        },
        {
          "sourceId": "it-mim-dm-43-2022",
          "locator": "Orientamenti nazionali 0–3 · esplorazione, gioco con materiali e costruzione di relazioni tra oggetti",
          "rationale": "Il concetto emerge dalla manipolazione e dal dialogo nell’esperienza concreta."
        }
      ],
      "materials": ["2–4 oggetti sicuri dello stesso tipo o molto simili, con dimensioni nettamente diverse"],
      "safetyConstraints": [
        "Anche l’oggetto più piccolo deve restare non ingeribile e adatto all’età.",
        "Evitare oggetti pesanti o instabili.",
        "Non insistere sul vocabolario grande/piccolo se il bambino preferisce esplorare fisicamente."
      ],
      "observationSignals": [
        "Il bambino nota o esplora la differenza di dimensione.",
        "Il bambino prova a scegliere, accoppiare o ordinare gli oggetti.",
        "Il bambino usa gesto o parola per indicare una differenza."
      ],
      "adaptation": {
        "ifEasy": "Aggiungere una dimensione intermedia o chiedere un confronto semplice durante il gioco.",
        "ifHard": "Usare solo due oggetti con differenza molto evidente e commentare la differenza senza chiedere una risposta.",
        "stopRule": "Interrompere quando l’interesse cala o la manipolazione non è più sicura."
      },
      "screen": {
        "classification": "adult-coach-off-screen",
        "expectedOnScreenSeconds": 20
      },
      "diagnosticUse": "none",
      "status": "implemented"
    },
    {
      "activityId": "ccd.24-36.draw-simple-marks",
      "skillId": "early.expression.draw-simple-marks.24-36",
      "title": "Tracciare segni e forme semplici",
      "ageBands": ["24-36-months"],
      "mode": "caregiver-mediated",
      "developmentalDomain": "Espressione grafica, movimento fine ed esplorazione",
      "objective": "Offrire un’occasione libera di lasciare segni, linee o forme semplici con materiali appropriati e sotto supervisione.",
      "sourceMappings": [
        {
          "sourceId": "who-unicef-ccd-2012",
          "locator": "Participant Manual · Recommendations · For the child, 2 years and older · p. 20 · PLAY",
          "rationale": "CCD propone il disegno con materiali semplici come attività di gioco per bambini di 2 anni e oltre."
        },
        {
          "sourceId": "it-mim-dm-43-2022",
          "locator": "Orientamenti nazionali 0–3 · molteplici linguaggi, espressione, esplorazione e materiali",
          "rationale": "L’attività valorizza il gesto grafico come linguaggio ed esplorazione, non come esercizio di calligrafia."
        }
      ],
      "materials": ["Supporto ampio e stabile", "Strumento grafico atossico, lavabile e appropriato all’età secondo indicazioni del produttore"],
      "safetyConstraints": [
        "Supervisione continua.",
        "Usare solo materiali certificati e adatti all’età; evitare strumenti appuntiti o parti piccole.",
        "Non correggere forma, impugnatura o risultato come se fosse un compito scolastico."
      ],
      "observationSignals": [
        "Il bambino produce segni o esplora il rapporto tra gesto e traccia.",
        "Il bambino ripete o varia il movimento spontaneamente.",
        "L’adulto descrive senza giudicare il prodotto."
      ],
      "adaptation": {
        "ifEasy": "Offrire un supporto diverso o modellare una linea/cerchio come possibilità, senza chiedere copia esatta.",
        "ifHard": "Aumentare la superficie disponibile e lasciare solo esplorazione libera del segno.",
        "stopRule": "Interrompere se il bambino porta il materiale alla bocca, lo usa in modo non sicuro o perde interesse."
      },
      "screen": {
        "classification": "adult-coach-off-screen",
        "expectedOnScreenSeconds": 25
      },
      "diagnosticUse": "none",
      "status": "implemented"
    },
    {
      "activityId": "ccd.24-36.simple-puzzle",
      "skillId": "early.problem-solving.simple-puzzle.24-36",
      "title": "Puzzle semplice a pezzi grandi",
      "ageBands": ["24-36-months"],
      "mode": "caregiver-mediated",
      "developmentalDomain": "Problem solving, percezione e coordinazione",
      "objective": "Esplorare un puzzle molto semplice con pochi pezzi grandi, lasciando al bambino tempo per provare e ripetere.",
      "sourceMappings": [
        {
          "sourceId": "who-unicef-ccd-2012",
          "locator": "Participant Manual · Recommendations · For the child, 2 years and older · p. 20 · PLAY",
          "rationale": "CCD propone esplicitamente picture puzzles con pezzi grandi come gioco per questa fascia."
        },
        {
          "sourceId": "it-mim-dm-43-2022",
          "locator": "Orientamenti nazionali 0–3 · gioco, esplorazione, problem solving e iniziativa",
          "rationale": "Il bambino sperimenta tentativi e soluzioni con supporto non direttivo dell’adulto."
        }
      ],
      "materials": ["Puzzle commerciale appropriato all’età con pochi pezzi grandi oppure materiale equivalente sicuro e robusto"],
      "safetyConstraints": [
        "Usare soltanto puzzle/materiali conformi all’età, senza piccoli pezzi o bordi pericolosi.",
        "Non improvvisare ritagli fragili o facilmente ingeribili.",
        "L’adulto aiuta solo quanto necessario e non completa sistematicamente il compito al posto del bambino."
      ],
      "observationSignals": [
        "Il bambino esplora orientamento e posizione dei pezzi.",
        "Il bambino ripete tentativi o chiede aiuto con gesto/parola.",
        "Il bambino resta coinvolto anche senza completare il puzzle."
      ],
      "adaptation": {
        "ifEasy": "Passare a un puzzle con un solo pezzo in più, purché appropriato all’età.",
        "ifHard": "Ridurre il numero di pezzi disponibili e mostrare dove va un pezzo senza completare tutto il puzzle.",
        "stopRule": "Interrompere quando il bambino perde interesse o manipola i pezzi in modo non sicuro."
      },
      "screen": {
        "classification": "adult-coach-off-screen",
        "expectedOnScreenSeconds": 25
      },
      "diagnosticUse": "none",
      "status": "implemented"
    },
    {
      "activityId": "ccd.24-36.picture-book-talk",
      "skillId": "early.communication.picture-book-talk.24-36",
      "title": "Guardare immagini e parlarne insieme",
      "ageBands": ["24-36-months"],
      "mode": "caregiver-mediated",
      "developmentalDomain": "Comunicazione, attenzione condivisa e pre-literacy",
      "objective": "Guardare insieme un libro illustrato o immagini semplici, fare domande brevi e ascoltare le risposte o i segnali del bambino.",
      "sourceMappings": [
        {
          "sourceId": "who-unicef-ccd-2012",
          "locator": "Participant Manual · Recommendations · For the child, 2 years and older · pp. 20–21 · COMMUNICATE",
          "rationale": "CCD raccomanda di parlare di immagini o libri e spiega che guardare libri illustrati e raccontare prepara alla lettura."
        },
        {
          "sourceId": "it-mim-dm-43-2022",
          "locator": "Orientamenti nazionali 0–3 · comunicazione, ascolto, narrazione, relazioni e molteplici linguaggi",
          "rationale": "L’adulto condivide attenzione e significati seguendo il contributo del bambino."
        }
      ],
      "materials": ["Libro illustrato robusto e adatto all’età oppure poche immagini grandi e appropriate"],
      "safetyConstraints": [
        "Preferire un libro fisico o immagini reali invece di prolungare la visione sul dispositivo.",
        "Non interrogare il bambino sulle immagini né correggere ogni parola.",
        "Seguire l’interesse del bambino e accettare risposte verbali e non verbali."
      ],
      "observationSignals": [
        "Il bambino guarda, indica, commenta o gira le pagine.",
        "Il bambino risponde a una domanda o avvia spontaneamente un commento.",
        "L’adulto ascolta e amplia lo scambio senza trasformarlo in verifica."
      ],
      "adaptation": {
        "ifEasy": "Chiedere una seconda domanda aperta molto semplice o collegare l’immagine a un’esperienza familiare.",
        "ifHard": "Limitarsi a nominare/commentare una sola immagine seguendo ciò che il bambino guarda.",
        "stopRule": "Concludere quando il bambino chiude il libro, cambia attività o mostra stanchezza."
      },
      "screen": {
        "classification": "adult-coach-off-screen",
        "expectedOnScreenSeconds": 20
      },
      "diagnosticUse": "none",
      "status": "implemented"
    },
    {
      "activityId": "ccd.24-36.stories-songs-games",
      "skillId": "early.communication.stories-songs-games.24-36",
      "title": "Storie, canzoni e giochi condivisi",
      "ageBands": ["24-36-months"],
      "mode": "caregiver-mediated",
      "developmentalDomain": "Comunicazione, memoria, relazione e gioco sociale",
      "objective": "Condividere una storia breve, una canzone o un semplice gioco verbale/motorio e rispondere con pazienza alle iniziative e domande del bambino.",
      "sourceMappings": [
        {
          "sourceId": "who-unicef-ccd-2012",
          "locator": "Participant Manual · Recommendations · For the child, 2 years and older · pp. 20–21 · COMMUNICATE; Counselling Cards · 2 YEARS AND OLDER · COMMUNICATE",
          "rationale": "CCD raccomanda esplicitamente storie, canzoni e giochi, incoraggiando il bambino a parlare e l’adulto a rispondere alle domande con pazienza."
        },
        {
          "sourceId": "it-mim-dm-43-2022",
          "locator": "Orientamenti nazionali 0–3 · relazioni, narrazione, musica, corpo e molteplici linguaggi",
          "rationale": "L’attività integra relazione, voce, movimento e narrazione in forma ludica."
        }
      ],
      "materials": ["Nessun materiale obbligatorio; opzionale un libro illustrato o oggetti sicuri collegati alla storia/gioco"],
      "safetyConstraints": [
        "Scegliere contenuti e movimenti appropriati all’età e al contesto.",
        "Non usare video passivi come sostituto della relazione con il caregiver.",
        "Non correggere in modo insistente errori linguistici: offrire un modello naturale e continuare lo scambio."
      ],
      "observationSignals": [
        "Il bambino ascolta, imita un gesto/suono, partecipa o propone una variazione.",
        "Il bambino fa una domanda o tenta di raccontare/cantare qualcosa.",
        "L’adulto risponde e segue l’iniziativa mantenendo un clima piacevole."
      ],
      "adaptation": {
        "ifEasy": "Lasciare al bambino scegliere una parte, completare un ritornello o proporre una variante del gioco.",
        "ifHard": "Ridurre a una canzone breve, una filastrocca o un singolo gesto ripetibile senza richiesta di risposta.",
        "stopRule": "Interrompere o cambiare attività se il bambino si disinteressa, si agita o chiede altro."
      },
      "screen": {
        "classification": "adult-coach-off-screen",
        "expectedOnScreenSeconds": 20
      },
      "diagnosticUse": "none",
      "status": "implemented"
    }
  ]
}
